<template>
    <div class="oxonium-ionen">
        <p>
            Universalindikator rot
            <br />
            H<sub>3</sub>O<sup>+</sup>
        </p>
    </div>
</template>

<script>
export default {
    name: 'oxonium-ionen',
};
</script>
